import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { format } from 'date-fns';
import { Field, reduxForm } from 'redux-form';
import _ from 'lodash';
import { saveSurvey, fetchSurvey, selectCurrentSurvey } from '../actions';
import { showSuccess, showError, showWarning } from '../../Common/alertmessage';
import CheckoutForm from '../../Common/checkout-form';
import LocalStrings from '../../../languages';
import { challengeStatus, showpopupModal } from '../../gamification/actions';
import { showToast } from '../../Common/alertmessage';

const SurveyForm = props => {
  const {
    session,
    deviceSize,
    handleSubmit,
    selectedSurvey,
    surveyModal = false
  } = props;
  const [loading, setLoading] = useState(false);

  let checkoutForm = !_.isEmpty(selectedSurvey)
    ? JSON.parse(selectedSurvey.formjson)
    : [];

  const onSubmitForm = data => {
    // console.log('form submit data', data);

    let local_responseArr = [],
      formSubmitObj = {
        eventid: session.eventid,
        appuserid: session.userid,
        formid: selectedSurvey?.formid,
        formnumber: selectedSurvey?.formnumber
      };

    if (checkoutForm.length > 0) {
      _.map(checkoutForm, (form, index) => {
        let name = form.name;
        if (data.hasOwnProperty(name)) {
          if (form.key == 'datepicker' && data[name] instanceof Date) {
            // form.value = data[name].toString();
            form.value = format(data[name], 'yyyy-MM-dd');
          } else {
            form.value = data[name];
          }
          local_responseArr.push(form);
        } else {
          form.value = '';
          if (form.key == 'checkboxes') {
            form.value = [];
          }
          local_responseArr.push(form);
        }
      });
    }

    formSubmitObj.responses = JSON.stringify(local_responseArr);
    // console.log({formSubmitObj});

    setLoading(true);
    props.saveSurvey(session, formSubmitObj, response => {
      if (response.success === 0) {
        setLoading(false);
        showError(LocalStrings.kSomethingWrong);
      } else {
        props.reset();
        props.selectCurrentSurvey({ ...selectedSurvey, surveytaken: true });
        props.fetchSurvey(session, res => {});
        // Gamification Status
        props.challengeStatus(session, 'survey', response => {
          setLoading(false);
          showSuccess(LocalStrings.kAnswerSubmittedText);
          if (response.data && response.data.iscompleted == true) {
            if (response.data.showpopup == true) {
              response.data.challengetype = 'survey';
              props.showpopupModal(true, response.data);
            } else if (response.data?.showpopup) {
              showToast(
                LocalStrings.kYouHaveGot +
                  ' ' +
                  response.data.points +
                  ' ' +
                  LocalStrings.kPointsText
              );
            }
          }
        });
      }
    });
  };

  let style = {
    height: surveyModal ? deviceSize.height - 450 : deviceSize.height - 90
  };
  let formHeight = {
    height: surveyModal
      ? deviceSize.height - (deviceSize.isMobile ? 360 : 310)
      : deviceSize.height - (deviceSize.isMobile ? 210 : 160)
  };

  return (
    <div>
      {selectedSurvey?.surveytaken ? (
        <div className="content-body scrollable-content" style={style}>
          <div className="no-content-message">
            <div>
              {/* <img src={} /> */}
              <div className="no-content-text">
                {LocalStrings.kSurveyResponded}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <form onSubmit={handleSubmit(onSubmitForm)}>
          <div className="content-body scrollable-content" style={formHeight}>
            <CheckoutForm
              callsForm="survey"
              {...props}
              dynamicForm={checkoutForm}
            />
          </div>
          <hr className="bottombar-devider" />
          <div className="bottom-container pl-3">
            <button
              type="submit"
              className="custom-button-primary-lg"
              disabled={loading}
            >
              {loading ? (
                <>
                  <i className={`fa fa-refresh fa-spin`}></i>
                  &ensp;
                  {LocalStrings.kSaveText}
                </>
              ) : (
                LocalStrings.kSaveText
              )}
            </button>
          </div>
        </form>
      )}
    </div>
  );
};

const validate = (values, ownProps) => {
  // console.log('values :- ', values);
  let errors = {};
  let checkoutForm = !_.isEmpty(ownProps.selectedSurvey)
    ? JSON.parse(ownProps.selectedSurvey.formjson)
    : [];

  _.map(checkoutForm, (form, index) => {
    let name = form.name;
    let formKey = form.key;

    if (
      form.required &&
      !_.isArray(values[name]) &&
      (!values[name] || values[name].trim() === '')
    ) {
      if (formKey == 'radiobuttons') {
        errors[form.id] = LocalStrings.requird;
      } else {
        errors[name] = LocalStrings.requird;
      }
    }
    if (form.required && _.isArray(values[name]) && values[name].length == 0) {
      errors[name] = LocalStrings.requird;
    }
    if (form.maxlen && values[name] && values[name].length > form.maxlen) {
      errors[name] = `Text max length ${form.maxlen}`;
    }
  });
  // console.log(errors);
  return errors;
};

const mapStateToProps = state => {
  return {
    session: state.session,
    deviceSize: state.deviceSize,
    selectedSurvey: state.selectedSurvey
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      saveSurvey,
      fetchSurvey,
      selectCurrentSurvey,
      challengeStatus,
      showpopupModal
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: 'SurveyDataForm',
    enableReinitialize: true,
    keepDirtyOnReinitialize: true
  })(SurveyForm)
);
